<script>
    import Icon from 'fa-svelte';
    import { createEventDispatcher } from 'svelte';

    import { faFile } from '@fortawesome/free-solid-svg-icons/faFile'
    import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
    import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
    import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'

    import { hiringApi } from 'src/api'

    let fileSelected = undefined;
    let uploadProgress = 0;
    export let value
    export let field

    const STEPS = { None: 0, Loading: 1, Success: 2, Error: 3 };
    const dispatch = createEventDispatcher();

    let step = STEPS.None

    const handleChange = async e => {
        if (!e.target.files.length) return
        fileSelected = e.target.files[0]

        const form = new FormData()
        form.append('field', field.title)
        form.append('file', fileSelected)
        try {
            step = STEPS.Loading
            uploadProgress = 0
            let { data } = await hiringApi.post('/upload/', form, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: e => uploadProgress = Math.round( (e.loaded * 100) / e.total ),
            })
            value = data
            step = STEPS.Success
            dispatch('upload', value);
            dispatch('change', value);
        } catch (e) {
            step = STEPS.Error
        }
    }

</script>

<div class="file-input">
    {#if fileSelected}
        <div class="file-input__label">
            {#if step == STEPS.Loading}
                <span class="spinner"><Icon icon={faSpinner} /></span>
                <strong>{uploadProgress}%</strong>
            {/if}
            {#if step == STEPS.Success}<span class="check-icon"><Icon icon={faCheck} /></span>{/if}
            {#if step == STEPS.Error}
                <span class="error-icon"><Icon icon={faTimes} /></span>
                <strong class="error-text">Error</strong>
            {/if}
            &nbsp;{fileSelected.name}
        </div>
    {:else}
        <div class="file-input__label"><Icon icon={faFile} />&nbsp;Click To Upload</div>
    {/if}

    <input type="file" class="file-input__file" on:input={handleChange} >
</div>

<style>
    .file-input {
        position: relative;
        height: 30px;
        width: 100%;
        top: 0;
        left: 0;
        padding: 0;
        margin: 0;
        color: #689eff;
        cursor: pointer;
    }
    .file-input__label {
        display: flex;
        align-items: center;
    }
    .file-input__label > * {
        margin-right: 5px;
    }
    .file-input__file {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        top:0;
        left:0;
        padding: 0;
        margin:0;
    }

    .spinner {
        display: inline-flex;
        animation: spinner 1.2s linear infinite;
    }

    .check-icon {
        display: inline-flex;
        color: #6CAE75;
    }

    .error-icon {
        display: inline-flex;
        color: #EF476F;
    }

    .error-text {
        color: #EF476F;
    }

    @keyframes spinner {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(359deg);
        }
    }
</style>
